module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Scale-276ab589c4bd7b328dc425f2456a1200.svg";